import React from 'react';
import ItinerariesView from '../../../components/itineraries';

function Itineraries(props){
  return(
    <ItinerariesView {...props}></ItinerariesView>
  );
};

export default Itineraries;